import Vue from "vue";
import VueRouter from "vue-router";
import HomeView from "../views/HomeView.vue";
import PortfolioView from "../views/PortfolioView.vue";
import TrackerView from "../views/TrackerView.vue";
import ISIHACView from "../views/ISIHACView.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  {
    path: "/portfolio",
    name: "portfolio",
    component: PortfolioView,
  },
  {
    path: "/tracking",
    name: "tracking",
    component: TrackerView,
  },
  {
    path: "/isihac",
    name: "isihac",
    component: ISIHACView,
  },
  {
    path: "/portfolio/:param",
    name: "portfolio-detail",
    component: PortfolioView,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
